/*
 * Copyright (c) by INFODATA-GROUP. All rights reserved.
 * No part of this publication may be reproduced, distributed,
 * or transmitted in any form or by any means, including photocopying, recording,
 * or other electronic or mechanical methods, without the prior written permission of the publisher,
 * except in the case of brief quotations embodied in critical
 * reviews and certain other noncommercial uses permitted by copyright law.
 *  author : vhe
 *  date : 02/03/2021 07:39
 */

import { Pipe, PipeTransform } from '@angular/core';
import { IComparator } from '../interface/icomparator';

@Pipe({
  name: 'order',
  standalone: true,
})
export class OrderPipe implements PipeTransform {
  transform(value: IComparator[], order: 'asc' | 'desc' = 'asc'): any {
    const index = order === 'asc' ? 1 : -1;
    return value.sort((a, b) => {
      return a.compare(b) * index;
    });
  }
}
